/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("CTAwithMarqueeGallery", ["jquery", "Behaviors"], factory);
    } else {
        root.CTAwithMarqueeGallery = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};

    function CTAwithMarqueeGallery() {
        Behaviors.init(CTAwithMarqueeGallery, this, arguments);
        this.element = this.$elem[0];

        this.initMarquee();

    }


    Behaviors.inherit(CTAwithMarqueeGallery, Behaviors.Behavior);

    CTAwithMarqueeGallery.QUERY = "[data-CTAwithMarqueeGallery]";

    CTAwithMarqueeGallery.ELEMENTS = {
        marqueeParent  : '.CTAwithMarqueeGallery .carouselTicker',
        marqueeWrapper: ".CTAwithMarqueeGallery .carouselTicker__list",
        marqueeItem: ".CTAwithMarqueeGallery .carouselTicker__item"
    };


    CTAwithMarqueeGallery.prototype.initMarquee = function() {

        // $( CTAwithMarqueeGallery.ELEMENTS.marqueeItem ).each(function(){

        //     if( $( CTAwithMarqueeGallery.ELEMENTS.marqueeWrapper ).children().length <= 15 ){

        //         $( CTAwithMarqueeGallery.ELEMENTS.marqueeWrapper ).append( $(this).clone() );
                   
        //     }

        // });

        $( CTAwithMarqueeGallery.ELEMENTS.marqueeParent ).carouselTicker({

            // animation speed
            speed: 2,
          
            // animation delay
            delay: 30,
          
            // or 'next'
            direction: "prev",
          
            // or 'vertical'
            mode: "horizontal",
          
            // callback
            onCarouselTickerLoad: function () {

                
            },
          
          });



    };


    
    Behaviors.register_behavior(CTAwithMarqueeGallery);

    module.CTAwithMarqueeGallery = CTAwithMarqueeGallery;

    return module;
}));



